import { Button } from '@pimbutton/tast-components-lib';
import React, { useEffect, useState } from 'react';
import './AuthVisual.module.scss';
import ProjectCard from 'components/UI/ProjectCard/ProjectCard';
import axios from 'axios';

type Props = {
  isExtern?: boolean;
  shareCode?: string;
};

export default function AuthVisual({ isExtern, shareCode }: Props) {
  const [project, setProject] = useState(null);
  useEffect(() => {
    if (shareCode) {
      axios.get(`/api/project/show-sharecode/${shareCode}`).then((p) => {
        setProject(p.data);
      });
    }
  }, [shareCode]);

  return (
    <div styleName="wrapper">
      {isExtern ? (
        <div styleName="extern" />
      ) : (
        <img
          alt="Groow"
          src="/images/artwork/groow-login-artwork.png"
          styleName="bg "
        />
      )}
      <div styleName={`center ${isExtern ? 'extern-center' : ''}`}>
        <img
          styleName={`logo ${isExtern ? 'extern-logo' : ''}`}
          alt="Groow"
          src="/images/Groow-logo.svg"
        />
        {isExtern && (
          <div styleName="project ">
            {' '}
            <p>
              Je hebt een uitnodiging ontvangen om het project van{' '}
              <span>
                {project?.author?.first_name} {project?.author?.last_name}
              </span>{' '}
              te volgen
            </p>
            <ProjectCard register theme={project?.theme} />{' '}
          </div>
        )}
        <a href="https://groow.tast.tools" target="_blank" rel="noreferrer">
          <Button variant="white">Meer weten?</Button>
        </a>
      </div>
    </div>
  );
}
